import { createSelector } from 'reselect';
import { AppState } from "../RootReducer";

export const getBonusConfigId = (state : AppState) => state.bonus.activeBonuses?.[0]?.bonusConfig?.id;

const getCasinoBonusGameIds = (state : AppState) => state.bonus.casinoBonusGameIds;

export const getAllCasinoBonusGameIds = createSelector(
    [getCasinoBonusGameIds],
    (casinoBonusGameIds) => {
        const allBonusGameIds = []

        for(const bonusKey in casinoBonusGameIds) {
                const bonus = casinoBonusGameIds[bonusKey];
                allBonusGameIds.push(...bonus);
        }

        return allBonusGameIds;
    }
);